import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';

import {FieldComponent} from '../../field/field.component';

// tslint:disable-next-line:no-duplicate-imports
// @ts-ignore
// tslint:disable-next-line:no-duplicate-imports
// @ts-ignore
import _moment, {default as _rollupMoment} from 'moment';
import {TranslateService} from '@ngx-translate/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DateRangeModel} from "../../models/date-range-selection-models/date-range-model";
import dayjs from "dayjs";


const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'L',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY-MM-DD',
    dateA11yLabel: 'L',
    monthYearA11yLabel: 'YYYY-MM-DD',
  },
};

@Component({
    selector: 'app-date-range',
    templateUrl: './date-range.component.html',
    styleUrls: ['./date-range.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})

export class DateRangeComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FieldComponent>,
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public translate: TranslateService) { }

  capturedFromDate;
  capturedToDate;
  currentDate = dayjs().format('YYYY-MM-DD');
  isCustomRange: boolean = false;

  ngOnInit(): void {
    this.capturedFromDate = dayjs().subtract(90, 'day').format('YYYY-MM-DD');
    this.capturedToDate = dayjs().format('YYYY-MM-DD');
  }

  applyDates() {
    var newFromDate = moment(this.capturedFromDate);
    var newToDate = moment(this.capturedToDate);
    if (newFromDate == null || newToDate == null) {
      this.dialogRef.close();
    } else if (newFromDate < newToDate) {

      this.dialogRef.close({ "fromDate": newFromDate, "toDate": newToDate });
    } else {
      this.openSnackBar(this.translate.instant("HISTORY-FILTER-DIALOG.DATE-ERROR"), this.translate.instant('SNACKBAR.DISMISS'));
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }

  handlePeriodSelection(period: DateRangeModel) {
    this.isCustomRange = period.description === 'Custom';
    this.capturedFromDate = period.period;
    this.capturedToDate = this.currentDate;
  }

}
